<template>
    <div>
        <el-dialog :visible.sync="visible" class="doedit" width="880px" :close-on-click-modal="false"
                   :before-close="resetForm">
            <div slot="title">
                <z-title :title="(type==0?'编辑':'新增')+'婚庆预定'"></z-title>

            </div>
            <div class="plr-20 content lh-30">
                <orderbase :info="info"></orderbase>
                <template>
                    <el-divider class="title" content-position="left">{{(type==0?'编辑':'新增')+'婚庆'}}</el-divider>
                    <el-form label-width="100px" :model="weddingInfo" :rules="rules" class="plr-20" size="medium"
                             ref="ruleForm">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="新郎姓名" :show-message="false" prop="maleName">
                                    <el-input maxlength="8" v-model="weddingInfo.maleName"
                                              placeholder="请输入新郎姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="新娘姓名" :show-message="false" prop="femaleName">
                                    <el-input maxlength="8" v-model="weddingInfo.femaleName"
                                              placeholder="请输入新娘姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="手机号码" prop="phoneMale">
                                    <el-input maxlength="11" v-model.number="weddingInfo.phoneMale"
                                              placeholder="请输入手机号码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="其他手机号码" prop="phoneFemale">
                                    <el-input maxlength="11" v-model.number="weddingInfo.phoneFemale"
                                              placeholder="请输入其他手机号码"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="典礼开始时间" prop="beginTime">
                                    <el-time-picker
                                            class="w-270"
                                            value-format="HH:mm:ss" format="HH:mm"
                                            :default-value="new Date(info.orderDate+' '+info.activityBeginTime+':00')"
                                            :picker-options="{
      selectableRange:info.activityBeginTime+':00-'+info.activityEndTime+':00'
    }"
                                            v-model="weddingInfo.beginTime"
                                            placeholder="选择典礼开始时间">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="婚庆套餐" :show-message="false" prop="weddingPackage">
                                    <wedding-package type="object" class="w-270" size="medium"
                                                     v-model="weddingInfo.weddingPackage"
                                                     placeholder="请选择婚庆套餐"></wedding-package>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="额外项目" prop="exItemMoney">
                                    <div class="flex-n w-270">
                                        <el-input-number class="mr-10" disabled v-model="weddingInfo.exItemMoney"
                                                         :controls="false" :precision="2" :step="0.1"
                                                         controls-position="right" :min="0"
                                                         :max="9999999999"></el-input-number>
                                        <el-button type="primary" @click="showextra = true">编辑查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="婚庆价格" :show-message="false" prop="orderMoney">
                                    <el-input placeholder="请输入婚庆价格" class="w-270" v-model="weddingInfo.orderMoney"
                                              v-number="{precision:2}">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="婚庆定金" :show-message="false" prop="downPayment">
                                    <el-input placeholder="请输入婚庆定金" class="w-270" v-model="weddingInfo.downPayment"
                                              v-number="{precision:2}">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="接待人员" prop="createUserName">
                                    <el-input maxlength="64" disabled v-model="info.createUserName"
                                              placeholder="请输入婚庆接待人员"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="备 注" prop="remark">
                                    <el-input type="textarea" rows="6" show-word-limit v-model="weddingInfo.remark"
                                              resize="none"
                                              maxlength="512"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item class="mt-10 flex-n fje">
                            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                            <el-button @click="resetForm">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </div>

        </el-dialog>

        <extra-list title="额外合计项目" v-model="weddingInfo.extraTree" :is-wedding="true" :visible.sync="showextra"
                    @getTotal="getTotal"></extra-list>

    </div>
</template>

<script>
    import ExtraList from "../../component/extra";
    import ZTitle from "../../../components/ZTitle";
    import Orderbase from "../../component/orderbase";
    import WeddingPackage from "../../../components/data/weddingPackage";

    export default {
        components: {
            WeddingPackage,
            Orderbase,
            ZTitle,
            ExtraList
        },
        name: "edit-wedding",
        props: {
            id: String,
            wedId: String,
            visible: Boolean,
            type: {
                type: Number | String,
                default: 0
            }
        },
        data() {
            var validatetel = (rule, value, callback) => {
                if (!this.$root.mobileformat.test(value) && value != '') {
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                info: {},
                showextra: false,
                weddingInfo: {
                    "orderId": "",
                    "maleName": "",
                    "femaleName": "",
                    "phoneMale": "",
                    "phoneFemale": "",
                    "beginTime": "",
                    "weddingPackage": {},
                    "exItemMoney": '',//额外项目金额
                    "weddingItemsExs": [],
                    "extra": {},
                    "orderMoney": "",
                    "downPayment": "",
                    "remark": ""
                },
                rules: {
                    maleName: [{required: true, trigger: 'blur'}],
                    femaleName: [{required: true, message: '新娘姓名不能为空', trigger: 'blur'}],
                    phoneMale: [{validator: validatetel, trigger: 'change'},
                        {required: true, message: '用户手机号不能为空', trigger: 'blur'}],
                    weddingPackage: [{required: true, trigger: 'change'}],
                    downPayment: [{required: true, trigger: 'blur'}],
                    orderMoney: [{required: true, trigger: 'blur'}]
                },
            }
        },
        watch: {
            visible(newval, oldval) {
                if (newval) {
                    if (this.id)
                        this.getData();
                    if (this.type == 1){
                        if (this.wedId)
                            this.getWedData();
                    }

                }
            }
        },
        methods: {
            getData() {
                this.$axios.get('/order/orderDetailById/' + this.id).then(res => {
                    console.log('基本信息', res)
                    this.info = res.data;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            getWedData() {
                this.$axios.get('/wedding/orderWeddingDetail/' + this.wedId).then(res => {
                    console.log('婚庆信息', res)
                    var weddingData = res.data;
                    weddingData.extraTree = {
                        itemsExTree: weddingData.extra
                    }
                    weddingData.weddingPackage = {
                        packageTypeCode: weddingData.weddingPackageId
                    };
                    // this.getSetmealList(newval.packageTypeCode);
                    this.weddingInfo = weddingData;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            getTotal(data) {
                console.log(this.weddingInfo.extra)
                this.weddingInfo.exItemMoney = data.nowPrice;
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.type == 0) {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            //添加提交
            addSubmit() {
                var weddata = this.weddingInfo;
                console.log(weddata.extra, weddata.extra.itemsExTree)
                this.$axios.post('/wedding/orderWeddingAdd', {
                    "storeId": this.$root.getStorage('storeId'),
                    "orderId": this.id,
                    "maleName": weddata.maleName,
                    "femaleName": weddata.femaleName,
                    "phoneMale": weddata.phoneMale,
                    "phoneFemale": weddata.phoneFemale,
                    "beginTime": weddata.beginTime,
                    "packageName": weddata.weddingPackage.packageName,
                    "packageId": weddata.weddingPackage.packageTypeCode,
                    "exItemMoney": weddata.exItemMoney,//额外项目金额
                    "weddingItemsExs": weddata.weddingItemsExs,
                    "extra": weddata.extraTree.itemsExTree,
                    "orderMoney": weddata.orderMoney,
                    "downPayment": weddata.downPayment,
                    "remark": weddata.remark
                }).then(res => {
                    this.$message.success('新增婚庆预定成功！');
                    this.$emit('refresh', this.info.orderDate);
                    this.resetForm();
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit() {
                var weddata = this.weddingInfo;
                this.$axios.post('/wedding/orderWeddingUpdate', {
                    "storeId": this.$root.getStorage('storeId'),
                    "id": weddata.id,
                    "weddingOrderId": this.wedId,
                    "orderId": this.id,
                    "maleName": weddata.maleName,
                    "femaleName": weddata.femaleName,
                    "phoneMale": weddata.phoneMale,
                    "phoneFemale": weddata.phoneFemale,
                    "beginTime": weddata.beginTime,
                    "packageName": weddata.weddingPackage.packageName,
                    "packageId": weddata.weddingPackage.packageTypeCode,
                    "exItemMoney": weddata.exItemMoney,//额外项目金额
                    "weddingItemsExs": weddata.weddingItemsExs,
                    "extra": weddata.extraTree.itemsExTree,
                    "orderMoney": weddata.orderMoney,
                    "downPayment": weddata.downPayment,
                    "remark": weddata.remark
                }).then(res => {
                    this.$message.success('编辑婚庆预定成功！');
                    this.$emit('refresh', this.info.orderDate);
                    this.resetForm();
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            resetForm() {
                this.loading = false;
                this.$refs.ruleForm.resetFields();
                this.$emit('update:visible', false)
            },
        }
    }
</script>

<style scoped>

</style>